import React from 'react';
import { Container } from 'react-bootstrap';
import { AuthProvider } from 'contexts/authContext';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import PrivateRoute from 'privateRoute';

import Login from './Login';
import ForgotPassword from './ForgotPassword'
import Dashboard from './views/Dashboard';
import requestforaprooval from './views/requestforaprooval';
import assigndrivers from './views/assigndrivers';
import emergencyrequest from './views/emergencyrequest';
import rostermanagement from './views/rostermanagement';
import displayshedule from './views/displayshedule';
import retreivedrivers from './views/retreivedrivers';
import UpdateShedulerDetails from './views/UpdateShedulerDetails';
import assigncompanyupdate from './views/assigncompanyupdate';
import Home from './Home';
import Signup from './Signup';

function App() {
  return (
    <>

      <Router>
      <AuthProvider>
  
      <Switch>

        <PrivateRoute path='/' exact component={Home} />
        <Route path='/signup' component={Signup} />
        <Route path='/login' component={Login} />
        <Route path='/forgot-password' component={ForgotPassword} />
        <Route path='/Dashboard' component={Dashboard} />
        <Route path='/requestforaprooval' component={requestforaprooval} />
        <Route path='/assigndrivers' component={assigndrivers} />
        <Route path='/emergencyrequest' component={emergencyrequest} />
        <Route path='/rostermanagement' component={rostermanagement} />
        <Route path='/displayshedule' component={displayshedule} />
        <Route path='/retreivedrivers' component={retreivedrivers} />
        <Route path='/UpdateShedulerDetails/:id' component={UpdateShedulerDetails} />
        <Route path='/assigncompanyupdate/:id' component={assigncompanyupdate} />
       
        
        
        </Switch>
        </AuthProvider>
      </Router>
    </>
  );
}

export default App;

